import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const Statement = ({
  size,
  type,
  theme,
  className,
  dataTestId = "statement-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path
      d="M3.61 2.06a2 2 0 0 1 2-2h7.644a2 2 0 0 1 2 2v10.328a.667.667 0 0 1-1.333 0V2.06a.667.667 0 0 0-.667-.666H5.61a.667.667 0 0 0-.667.666v.314h5.445a2 2 0 0 1 2 2V14.59c0 1.096-1.249 1.724-2.129 1.07l-.845-.629a.667.667 0 0 0-.833.03l-.256.22c-1.01.871-2.51.86-3.508-.023l-.214-.19a.667.667 0 0 0-.834-.04l-.907.659c-.881.64-2.117.01-2.117-1.08V4.375a2 2 0 0 1 2-2h.865V2.06Zm-.864 1.648a.667.667 0 0 0-.667.666v10.233l.908-.66a2 2 0 0 1 2.5.122l.215.19c.5.441 1.249.447 1.754.011l.256-.22a2 2 0 0 1 2.499-.09l.845.629V4.374a.667.667 0 0 0-.667-.666H2.746Zm1.311 4.624H9.08a.667.667 0 0 1 0 1.334H4.057a.667.667 0 0 1 0-1.334ZM3.391 5.6c0 .368.298.667.666.667h1.23a.667.667 0 0 0 0-1.333h-1.23a.667.667 0 0 0-.666.666Zm.666 5.167H6.46a.667.667 0 0 1 0 1.334H4.057a.667.667 0 1 1 0-1.334Z"
      fillRule="evenodd"
      clipRule="evenodd"
    />
  </SVGIcon>
);
